import React from "react";

const VerifiedMutedIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="menu-steps__check-mark--circle"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
      fill="#AAAAAA"
    />
    <path
      className="menu-steps__check-mark--check"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.37036 7.73259L4.70351 6.40112L5.99851 7.70118L9.81499 3.88892L11.1481 5.22038L6.00501 10.3704L3.37036 7.73259Z"
      fill="#333333"
    />
  </svg>
);

export default VerifiedMutedIcon;
